import { Fragment } from "react";
import { Grid } from "@mui/material";
import {
  AvailableIntegration,
  AvailableIntegrationCard,
} from "~/pages/integrations/components/available-integrations/available-integration-cards-list/AvailableIntegrationCard";
import { AvailableRecommendedIntegrationCard } from "~/pages/integrations/components/available-integrations/available-integration-cards-list/AvailableRecommendedIntegrationCard";
import { AvailableIntegrationCardDivider } from "~/pages/integrations/components/available-integrations/available-integration-cards-list/AvailableIntegrationCardDivider";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

export interface IntegrationCardsListProps {
  scope: SpaceScope | OrganizationScope;
  integrations: AvailableIntegration[];
  title?: string;
  recommended?: boolean;
}

export const AvailableIntegrationCardsList = ({
  scope,
  title,
  integrations,
  recommended = false,
}: IntegrationCardsListProps) => {
  return (
    <Fragment>
      {title && (
        <AvailableIntegrationCardDivider
          {...{ title, className: "integration-cards-list-divider" }}
        />
      )}
      <Grid container spacing={3} className="integration-cards-list">
        {integrations.map((integration, i) => {
          return (
            <Grid
              key={i}
              className="integration-cards-list-item"
              size={{
                xs: 12,
                sm: 6,
                md: 4,
              }}
            >
              {recommended ? (
                <AvailableRecommendedIntegrationCard
                  {...{ scope, integration }}
                />
              ) : (
                <AvailableIntegrationCard {...{ scope, integration }} />
              )}
            </Grid>
          );
        })}
      </Grid>
    </Fragment>
  );
};
